import React from 'react';
import Footer from '../../components/Layout/Footer';
import { getAuthToken, storeUserData } from '../../components/Util';
import SubHeader from '../../components/Layout/SubHeader';
import strings from '../../components/Language';
import { withRouter } from '../../config/withRouter';

class NotificationViewScreen extends React.Component {
    constructor(props) {
        super(props);
        const { location } = this.props;
        const data = location.state || {};
        this.state = {
            lang: strings.getLanguage(),
            access_token: null,
            errorMessage: [],
            data: data,
        }
    }

    async componentDidMount() {
        const self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, self);
        }
    }

    formatDate = (date) => {
        // Convert to DD/MM/YYYY
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };
    
    render() {
        return (
            <>
                <div className="NotificationScreen">
                    <SubHeader data={{ title: strings["Announcement"] }} />

                    <main className="notification-container">
                        <div className='notification-section-row'>
                            <div className="align-content">
                                <img src={this.state.data.documents_url} className="notification-image" alt='' />
                            </div>
                            <div className="align-content">
                                <p dangerouslySetInnerHTML={{ __html: this.state.data.en_memo ? this.state.data.en_memo : '' }}></p>
                            </div>
                            <div className="align-content-date">
                                <p className='date'>{this.formatDate(this.state.data.created_at)}</p>
                            </div>
                        </div>
                    </main>

                    <Footer />
                </div>
            </>
        );
    }
}

export default withRouter(NotificationViewScreen);
